<div oui-dialog-title>
  @if (displayAddSignataire()) {
    <div class="flex-horizontal flex-center width-fill-available">
      <oui-button
        class="right-margin-16"
        (click)="toggleAddSignataire(false)"
        type="icon"
        color="secondary">
        <oui-icon>arrow_back</oui-icon>
      </oui-button>
      <h6>Ajouter un signataire</h6>
    </div>
  } @else if (displayAddDocument()) {
    <div class="flex-horizontal flex-center width-fill-available">
      <oui-button
        class="right-margin-16"
        (click)="displayAddDocument.set(undefined)"
        type="icon"
        color="secondary">
        <oui-icon>arrow_back</oui-icon>
      </oui-button>
      <h6>Ajouter un document</h6>
    </div>
  } @else {
    <div class="flex-horizontal flex-center width-fill-available">
      <h6>Envoyer en signature</h6>
    </div>
  }
  <div class="content-right width-100-pc">
    <oui-button
      color="secondary"
      type="icon">
      <oui-icon mat-dialog-close>close</oui-icon>
    </oui-button>
  </div>
</div>
<oui-dialog-content
  class="content"
  [scroll]="true">
  @if (globalError()) {
    <lib-request-error-page></lib-request-error-page>
  } @else if (displayAddSignataire()) {
    <app-add-signataire
      (addSignataire)="addSignataire($event)"
      [selectedInvestisseurIds]="selectedInvestisseurIds()"
      [investisseurs]="investisseursRelations()">
    </app-add-signataire>
  } @else if (displayAddDocument()) {
    <app-add-document-signature
      #addDocumentSignatureDocument
      [addDocumentType]="displayAddDocument()"
      [documentsToDismiss]="documentsToDismiss()">
    </app-add-document-signature>
  } @else {
    <div class="flex-horizontal flex-center">
      <h6>Signataires</h6>
      <oui-button
        class="margin-left-8"
        type="text"
        (click)="toggleAddSignataire(true)">
        Ajouter un signataire
      </oui-button>
    </div>
    <div class="margin-top-16">
      <div
        class="margin-top-16"
        cdkDropList
        (cdkDropListDropped)="dropSignataire($event)">
        @for (signataire of form.controls.signataires.controls; track signataire) {
          <div
            class="signataire-card oui-elevation-04"
            cdkDrag>
            <div
              class="flex-horizontal flex-center justify-space-between gap-10"
              [ngClass]="{ disabled: !signataire.value.isActive }">
              <oui-button
                type="icon"
                color="secondary"
                cdkDragHandle>
                <oui-icon> drag_indicator </oui-icon>
              </oui-button>
              <oui-number
                [color]="'#bd1d1d'"
                [fill]="true"
                [value]="signataire.value.order ?? 0">
              </oui-number>
              <div>
                <div class="subtitle-2">{{ signataire.value.firstName }} {{ signataire.value.lastName }}</div>
                @if (signataire.value.representantDeNom) {
                  <div class="caption">Représentant légal de {{ signataire.value.representantDeNom }}</div>
                }
                @if (!signataire.valid) {
                  <div class="caption color-primary-500">Le signataire doit avoir un e-mail et mobile valides</div>
                }
              </div>
            </div>
            <div class="flex-horizontal flex-center gap-24 consultant-info">
              <div
                class="flex-horizontal flex-center justify-space-between width-100-pc gap-12"
                [ngClass]="{ disabled: !signataire.value.isActive }">
                <div>
                  <div>{{ signataire.value.email?.adresse }}</div>
                  @if (isTestEnv && signataire.value.signataireType === signataireType.Consultant) {
                    <div class="caption color-primary-500">En test, il sera envoyé à {{ signatureTestMail }}</div>
                  }
                </div>
                <div>{{ signataire.value.telephone?.numero }}</div>
              </div>
              <div class="remove-button">
                @if (signataire.value.signataireType === signataireType.Consultant || signataire.value.id === investisseur1Id()) {
                  <oui-slide-toggle
                    [control]="signataire.get('isActive')"
                    (valueChange)="toggleSignataireActive($event, $index)">
                  </oui-slide-toggle>
                } @else {
                  <oui-button
                    color="secondary"
                    type="icon"
                    (click)="removeSignataire($index)">
                    <oui-icon>delete</oui-icon>
                  </oui-button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="flex-horizontal flex-center padding-vertical-24">
      <h6>Documents à signer</h6>
      <oui-menu [menuItems]="addDocumentMenuItems">
        <oui-button
          class="margin-left-8"
          type="text">
          Ajouter un document
        </oui-button>
      </oui-menu>
      <oui-button
        iconPrefix="check_box"
        class="margin-left-8"
        type="text"
        (click)="toggleAllSignataires(true)">
        Sélectionner tous les signataires
      </oui-button>
    </div>
    <div>
      @if (form.controls.documents.value.length > 0) {
        <oui-table lineSizing="dense">
          <table
            class="document-table"
            mat-table
            [trackBy]="trackByControl"
            [dataSource]="documents.controls"
            cdkDropList
            [cdkDropListData]="documents.controls"
            (cdkDropListDropped)="dropDocument($event)"
            [cdkDropListDisabled]="dragDocumentDisabled()">
            <ng-container matColumnDef="dragHandle">
              <th
                mat-header-cell
                *matHeaderCellDef></th>
              <td
                mat-cell
                *matCellDef="let element">
                <oui-button
                  type="icon"
                  color="secondary"
                  cdkDragHandle
                  (mousedown)="dragDocumentDisabled.set(false)"
                  (mouseup)="dragDocumentDisabled.set(true)">
                  <oui-icon>drag_indicator</oui-icon>
                </oui-button>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                *matHeaderCellDef></th>
              <td
                mat-cell
                *matCellDef="let element">
                <lib-status-tag [status]="element.value.stepStatus"></lib-status-tag>
                @if (element.value.stepStatus === StepStatusEnum.Signed && !!element.value.dateReference) {
                  <div class="caption color-on-surface-medium">le&nbsp;{{ element.value.dateReference | date: 'dd/MM/yyyy' }}</div>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="document">
              <th
                mat-header-cell
                *matHeaderCellDef>
                Document
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                [ouiTooltip]="element.value.tooltip">
                <div class="body-2 flex-horizontal flex-center gap-8">
                  @if (element.value.url) {
                    <a
                      [href]="element.value.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="document-link"
                      (click)="$event.stopPropagation()">
                      {{ element.value.filename }}
                    </a>
                  } @else if (!element.value.isFakeFile) {
                    <a
                      class="document-link"
                      (click)="onDocumentNameClick(element); $event.stopPropagation()">
                      {{ element.value.filename }}
                    </a>
                    @if (isGenerating(element)) {
                      <oui-loading size="xs"></oui-loading>
                    }
                  } @else {
                    {{ element.value.filename }}
                  }
                </div>
                <div class="caption color-on-surface-medium">
                  {{ element.value.description }}
                </div>
              </td>
            </ng-container>

            @for (sign of getSignataires(0).controls; let sIndex = $index; track sign) {
              <ng-container [matColumnDef]="'signataire-' + sign.value.signataireId">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  {{ getSignataireName(sign.value.signataireId) }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element">
                  @if (!element.value.isFakeFile && !element.controls.signataires.at(sIndex).get('selected')?.disabled) {
                    <oui-checkbox [control]="element.controls.signataires.at(sIndex).get('selected')"> </oui-checkbox>
                  }
                </td>
              </ng-container>
            }

            <ng-container matColumnDef="option">
              <th
                mat-header-cell
                *matHeaderCellDef></th>
              <td
                mat-cell
                *matCellDef="let element; let i = index">
                @if (element.value.canDelete) {
                  <oui-button
                    type="icon"
                    color="secondary"
                    (click)="removeDocument(i)">
                    <oui-icon>delete</oui-icon>
                  </oui-button>
                } @else if (!element.value.isFakeFile) {
                  <oui-slide-toggle
                    class="margin-left-6"
                    [control]="element.get('isActive')"
                    (valueChange)="toggleDocumentActive($event, element)">
                  </oui-slide-toggle>
                }
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="documentTableColumns()"></tr>
            <tr
              mat-row
              cdkDrag
              *matRowDef="let row; columns: documentTableColumns()"
              [ngClass]="{ disabled: !row.value.isActive }"></tr>
          </table>
        </oui-table>
      } @else {
        <oui-etat-vide [title]="'Aucun document sélectionné'"> </oui-etat-vide>
      }
    </div>
  }
  @if (loading() || saving()) {
    <div class="loading-container">
      @if (loading()) {
        <oui-loading></oui-loading>
      }
    </div>
  }
</oui-dialog-content>
@if (!globalError()) {
  @if (saving()) {
    <oui-dialog-actions>
      <oui-loading
        size="xs"
        class="align-self-center">
      </oui-loading>
    </oui-dialog-actions>
  } @else if (displayAddDocument()) {
    <oui-dialog-actions>
      <oui-button
        type="contained"
        (click)="addDocuments()"
        [disabled]="
          !addDocumentSignatureComponent ||
          !addDocumentSignatureComponent.getSelectedDocuments() ||
          addDocumentSignatureComponent.getSelectedDocuments().length === 0
        ">
        Ajouter
      </oui-button>
    </oui-dialog-actions>
  } @else if (!displayAddSignataire()) {
    <oui-dialog-actions>
      @if (!loading()) {
        <div [ouiTooltip]="errorTooltip()">
          <oui-button
            type="contained"
            [disabled]="!isFormValid()"
            (click)="sendToSignature()">
            Envoyer en signature
          </oui-button>
        </div>
      }
    </oui-dialog-actions>
  }
}
